import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserOnboardingService } from '../../../public/user-onboarding/user-onboarding.service';
import { SharedService } from '../../../shared/shared.service';
import { ProfileService } from '../../profile.service';
import { EDIT_PROFILE_MODAL_TYPE } from '../../types/edit-profile-modal-types.enum';
import { User } from '../../types/user.model';
import { AddIndustryModalComponent } from '../add-industry-modal/add-industry-modal.component';
import { AddPersonaModalComponent } from '../add-persona-modal/add-persona-modal.component';
import { AddSpokenLanguagesModalComponent } from '../add-spoken-languages-modal/add-spoken-languages-modal.component';
import { AddWorldConnectionsModalComponent } from '../add-world-connections-modal/add-world-connections-modal.component';
import { PROFESSIONAL_PROFILE_EDIT_MODE } from '../step-proffesional-profile/step-proffesional-profile.component';

@Component({
  selector: 'mmb-web-app-step-identity',
  templateUrl: './step-identity.component.html',
  styleUrls: ['./step-identity.component.scss']
})
export class StepIdentityComponent implements OnInit, AfterViewInit {
  @Output() updateUser: EventEmitter<any> = new EventEmitter<any>();
  @Input() user: User;
  personas: any[];
  userCountryConnections: any[];
  countriesConnections: any;
  languageProficiencyLevels: any[];
  private _industries;

  constructor(private userOnboardingService: UserOnboardingService,
    private profileService: ProfileService,
    private modalService: NgbModal,
    private sharedService: SharedService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this._getPersonaOptions();
    this._getUserCountryConnections();
    this._getProficiencyLevels();

    this.sharedService.referenceTypes$.subscribe((value) => {
      if (value) {
        this._industries = value.type_reference_industry_secondary;
      }
    });
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe((params) => {
      if (params) {
        if (params.edit === EDIT_PROFILE_MODAL_TYPE.INDUSTRY) {
          this.openIndustryModal();
        }
      }
    });
  }

  getPersona(id: number) {
    return this._findItemById(this.personas, id);
  }

  openPersonaModal() {
    const modalRef = this.modalService.open(AddPersonaModalComponent, {
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
      if (ev) {
        this.user.credentials.candidate_type_user = ev;
      }
    });

    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  openIndustryModal() {
    const modalRef = this.modalService.open(AddIndustryModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.editMode = PROFESSIONAL_PROFILE_EDIT_MODE.INDUSTRY;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
      if (ev && ev.industry) {
        this.user.credentials.industry_secondary = ev.industry.value;
      }
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  openSpokenLanguagesModal() {
    const modalRef = this.modalService.open(AddSpokenLanguagesModalComponent, {
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.selectedLanguages = this.user.languages;
    modalRef.componentInstance.proficiencyLevels = this.languageProficiencyLevels;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  openWorldConnectionsModal() {
    const modalRef = this.modalService.open(AddWorldConnectionsModalComponent, {
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.countriesConnections = this.countriesConnections;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
      this.userCountryConnections = null;
      this._getUserCountryConnections();
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  getIndustry(industry: number) {
    let selectedIndustry = this._industries.find((item) => item.value === industry);
    return selectedIndustry ? selectedIndustry.name : '';
  }

  private _getUserCountryConnections() {
    this.profileService.getUserInternational().subscribe(res => {
      this.countriesConnections = res;
      this._mapCountriesConnections(res);
    });
  }

  private _mapCountriesConnections(connections: any[]) {
    let connectionsBuffer = [];
    for (let connection of connections) {
      if (!connectionsBuffer[connection.country.id]) {
        connectionsBuffer[connection.country.id] = {
          country: connection.country,
          uuid: connection.uuid,
          country_statuses: []
        };
      }

      connection.country_status.recordUuid = connection.uuid;
      connectionsBuffer[connection.country.id].country_statuses.push(connection.country_status);
    }
    this.userCountryConnections = connectionsBuffer;
  }

  private _getProficiencyLevels() {
    this.sharedService.getLanguageProficiencyLevels().subscribe((response) => {
      this.languageProficiencyLevels = response;
    })
  }

  private _getPersonaOptions() {
    this.userOnboardingService.getUserProfileReferenceType().subscribe((response) => {
      this.personas = response;
    })
  }

  private _findItemById(items: any[], id: any) {
    return items ? items.find((item) => item.value === id) : null;
  }
}
